import { combineReducers } from 'redux';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale, { LocaleState } from './locale';
import authentication, { AuthenticationState } from './authentication';
import applicationProfile, { ApplicationProfileState } from './application-profile';

import administration, { AdministrationState } from 'app/modules/administration/administration.reducer';
import userManagement, { UserManagementState } from 'app/modules/administration/user-management/user-management.reducer';
import register, { RegisterState } from 'app/modules/account/register/register.reducer';
import activate, { ActivateState } from 'app/modules/account/activate/activate.reducer';
import password, { PasswordState } from 'app/modules/account/password/password.reducer';
import settings, { SettingsState } from 'app/modules/account/settings/settings.reducer';
import passwordReset, { PasswordResetState } from 'app/modules/account/password-reset/password-reset.reducer';
// prettier-ignore
import jobOrder, {
  JobOrderState
} from 'app/entities/job-order/job-order.reducer';
// prettier-ignore
import jobOrderOwner, {
  JobOrderOwnerState
} from 'app/entities/job-order-owner/job-order-owner.reducer';
// prettier-ignore
import tSEntry, {
  TSEntryState
} from 'app/entities/ts-entry/ts-entry.reducer';
// prettier-ignore
import businessUnit, {
  BusinessUnitState
} from 'app/entities/business-unit/business-unit.reducer';
// prettier-ignore

// prettier-ignore
import employee, {
  EmployeeState
} from 'app/entities/employee/employee.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly locale: LocaleState;
  readonly applicationProfile: ApplicationProfileState;
  readonly administration: AdministrationState;
  readonly userManagement: UserManagementState;
  readonly register: RegisterState;
  readonly activate: ActivateState;
  readonly passwordReset: PasswordResetState;
  readonly password: PasswordState;
  readonly settings: SettingsState;
  readonly jobOrder: JobOrderState;
  readonly jobOrderOwner: JobOrderOwnerState;
  readonly tSEntry: TSEntryState;
  readonly businessUnit: BusinessUnitState;
  readonly employee: EmployeeState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly loadingBar: any;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  jobOrder,
  jobOrderOwner,
  tSEntry,
  businessUnit,
  employee,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar
});

export default rootReducer;
